import { render, staticRenderFns } from "./RouteRootComponent.vue?vue&type=template&id=79595fd4"
import script from "./RouteRootComponent.vue?vue&type=script&lang=js"
export * from "./RouteRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79595fd4')) {
      api.createRecord('79595fd4', component.options)
    } else {
      api.reload('79595fd4', component.options)
    }
    module.hot.accept("./RouteRootComponent.vue?vue&type=template&id=79595fd4", function () {
      api.rerender('79595fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/wrappers/RouteRootComponent.vue"
export default component.exports